import {Validator} from 'vee-validate'
import _ from 'lodash'

var defaultMsgs = {
    required: () => '该项不能为空',
    integer: () => '该项必须为整数',
    digits: () => '该项必须为正整数',
    number: () => '该项必须为数字',
    mobilePhone: () => '手机号码格式不正确',
    email: () => '邮箱格式不正确',
    regex: () => '格式不正确',
    max: rule => `不能大于${rule.value}`,
    min: rule => `不能小于${rule.value}`,
    length: rule => {
        var msg = '';
        if (rule.max || rule.max == 0) {
            msg = `不能超过${rule.max}个字`
        }
        if (rule.min || rule.min == 0) {
            msg += ` 不能少于${rule.min}个字`
        }
        return msg;
    },
    dateRange: rule => {
        var result = rule.validateResult;
        if(!result){
            return '校验不通过';
        }
        if(!result.required){
            return '该项不能为空';
        }
        if(!result.startLeEnd){
            return '开始时间必须小于结束时间';
        }
        if(!result.endGtNow){
            return '结束时间必须晚于当前时间';
        }
    },
}

function message(validatorName, args) {
    var rule = args && args.length ? args[0] : {};

    if (rule.message) {
        if (typeof rule.message === 'string') {
            return rule.message;
        } else {
            if (rule.validateResult) {
                for (let p in rule.validateResult) {
                    if (!rule.validateResult.hasOwnProperty(p)) continue;
                    if (!rule.validateResult[p] && rule.message[p]) {
                        return rule.message[p]
                    }
                }
            }
        }
    }
    var tpl = defaultMsgs[validatorName];
    if (!tpl) {
        return '校验不通过'
    }
    return tpl(rule)
}


var validators = {
    /**
     * 判断value为空,其实就是!required, 加这个是为了更容易理解
     * @param value
     * @returns {boolean}
     */
    optional: function (value) {
        return !this.required(null, value);
    },
    required: function (rule, value) {
        if (value === undefined || value === null) {
            return false;
        }
        //转成String, 否则0、false这种值也会校验不通过
        value = "" + value;
        return !!value;
    },
    max: function (rule, value) {
        if (this.optional(value)) return true;

        value = +value;

        return value <= rule.value;
    },
    min: function (rule, value) {
        if (this.optional(value)) return true;

        value = +value;

        return value >= rule.value;
    },
    /**
     * 整数
     * @param rule
     * @param value
     * @returns {*}
     */
    integer: function (rule, value) {
        if (this.optional(value)) return true;
        return (+value) % 1 === 0;
    },
    /**
     * 正整数
     * @param rule
     * @param value
     * @returns {boolean}
     */
    digits: function (rule, value) {
        if (this.optional(value)) return true;
        return /^\d+$/.test(value);
    },
    /**
     * 正数
     * @param rule
     * @param value
     * @returns {boolean}
     */
    positive: function (rule, value) {
        if (this.optional(value)) return true;
        return (+value) >= 0;
    },
    number: function (rule, value) {
        if (this.optional(value)) return true;

        value = +value;
        return !isNaN(value);
    },
    mobilePhone: function (rule, value) {
        if (this.optional(value)) return true;
        return /^[1][3456789][0-9]{9}$/.test(value);
    },
    date: function (rule, value) {
        //todo
        return true;
    },
    /**
     * todo: 支持中文邮箱
     * @param rule
     * @param value
     * @returns {boolean}
     */
    email: function (rule, value) {
        if (this.optional(value)) return true;
        return /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/.test(value);
    },
    regex: function (rule, value) {
        if (this.optional(value)) return true;
        return rule.pattern.test(value);
    },
    length: function (rule, value) {
        if (this.optional(value)) return true;

        //转成String, 否则0、false这种值也会校验不通过
        value = "" + value;

        if ((rule.min || rule.min == 0) && value.length < rule.min) {
            return false;
        }
        if ((rule.max || rule.max == 0) && value.length > rule.max) {
            return false;
        }
        return true;
    },
    dateRange: (rule, value) => {
        rule.validateResult = {
            required: false
        };
        if (value === undefined || value === null) {
            return false;
        }
        if (!(value instanceof Array) || value.length != 2) {
            return false;
        }
        rule.validateResult.required = value[0] instanceof Date && value[1] instanceof Date;
        if (!rule.validateResult.required) {
            return false;
        }
        var start = value[0];
        var end = value[1];
        rule.validateResult.startLeEnd = start <= end;
        if (!rule.validateResult.startLeEnd) {
            return false;
        }
        rule.validateResult.endGtNow = end > new Date();
        if (!rule.validateResult.endGtNow) {
            return false;
        }
        return true;
    }
}


export default {
    adapt() {
        for (let p in validators) {
            if (!validators.hasOwnProperty(p)) continue;

            var validator = {
                messages: {
                    zh_CN: (field, args) => {
                        return message(p, args)
                    }
                },
                validate(value, args) {
                    var rule = args && args.length ? args[0] : {};
                    return validators[p](rule, value)
                }
            }
            Validator.extend(p, validator)
        }
    }
}



// WEBPACK FOOTER //
// ./src/assets/js/validator.js